import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

import { renderNotification } from "../../services/notifications/notificationRenderer";
import {
  getEntityLabel,
  getEntityPalette,
} from "../../services/notifications/entityChipColors";
import NotificationParts from "./NotificationParts";
import { UserDetailIcon } from "../UserDetailIcon";

dayjs.extend(relativeTime);

const ResourceChip = ({ resourceType }) => {
  if (!resourceType) return null;
  const { bg, fg } = getEntityPalette(resourceType);
  return (
    <Box
      component="span"
      sx={{
        alignSelf: "flex-start",
        padding: "1px 6px",
        borderRadius: "4px",
        fontSize: 11,
        fontWeight: 500,
        backgroundColor: bg,
        color: fg,
        userSelect: "none",
      }}
    >
      {getEntityLabel(resourceType)}
    </Box>
  );
};

const NotificationItem = ({ delivery, onRead, onNavigate }) => {
  const { event, read } = delivery;
  const actorName = event?.actor?.name || "System";
  const rendered = renderNotification({
    eventType: event?.eventType,
    metadata: event?.metadata || {},
    resourceType: event?.resourceType,
    actorName,
  });

  const handleClick = () => {
    if (!read && onRead) onRead(delivery.id);
  };

  return (
    <Stack
      direction="row"
      gap="10px"
      alignItems="flex-start"
      sx={(theme) => ({
        padding: "10px 12px",
        cursor: "pointer",
        borderRadius: "6px",
        position: "relative",
        "&:hover": {
          backgroundColor: theme.palette.hubColors.greyLightest,
        },
      })}
      onClick={handleClick}
    >
      <UserDetailIcon
        size={28}
        user={{ ...event?.actor, hueShift: event?.actor?.id }}
        includeDetails={false}
      />
      <Stack flex={1} gap="4px" minWidth={0}>
        <NotificationParts parts={rendered.parts} onNavigate={onNavigate} />
        {rendered.preview && (
          <Typography
            variant="caption"
            fontSize={11}
            color="text.disabled"
            fontStyle="italic"
            noWrap
          >
            {rendered.preview}
          </Typography>
        )}
        <ResourceChip resourceType={event?.resourceType} />
        <Stack direction="row" justifyContent="space-between" gap="10px">
          <Typography variant="caption" fontSize={10} color="text.disabled">
            {dayjs(event?.createdAt).format("MM/DD/YYYY hh:mm A")}
          </Typography>
          <Typography variant="caption" fontSize={10} color="text.disabled">
            {dayjs(event?.createdAt).fromNow()}
          </Typography>
        </Stack>
      </Stack>
      {!read && (
        <Stack
          sx={{
            width: 8,
            minWidth: 8,
            height: 8,
            borderRadius: "50%",
            backgroundColor: "hubColors.mainFocus",
            position: "absolute",
            top: "14px",
            right: "12px",
          }}
        />
      )}
    </Stack>
  );
};

export default NotificationItem;
